import { SubscribeSignalRInvocationsSchema } from "domains/native/schemas/SubscribeSignalRInvocationsSchema";

import { createSubscriptionReducer } from "./createSubscriptionReducer";

export const reducer = createSubscriptionReducer({
    name: "SubscribeSignalRInvocations",
    schema: SubscribeSignalRInvocationsSchema,
});
